define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,Widget,xml,Query) {

	/**
	 * This module is view controller for BOM/Spec->"New from Spec item" toolbar action
	 */

	var SECTION = "SpecificationSection";
	var SPEC_ITEMS = "SpecItems";

	return declare(Widget, {
		getFieldStore: function(field, value) {
			switch (field.getControlName()) {
				case SECTION:
					return this.sectionsStore;

				case SPEC_ITEMS:
					let store = this.inherited(arguments);
					const parent = this.defView.m_formData.getParent();
					const subtype = this.cacheView.getNode(parent.Master).Subtype;

					let q = new Query().RefAttr("Subtype", xml.OP_EQUALS, subtype);
					store.action = lang.mixin(new Action(),{
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: "SpecificationItemDefinitionSelection",
							m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null"
						}),
						m_fixedQuery: q
					});
					return store;
			}
		}
	});
});